import AsideMenuStore from "@/modules/core/store/aside/aside_menu.store";

export default {
  modules: {
    AsideMenuStore,
  },
};
